(function(){
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lang = 'en';

  /* ---------- Language ---------- */
  var i18n = Array.prototype.slice.call(document.querySelectorAll('[data-ar]'));
  i18n.forEach(function(el){ el.setAttribute('data-en', el.innerHTML); });
  var phs = Array.prototype.slice.call(document.querySelectorAll('[data-ar-ph]'));
  phs.forEach(function(el){ el.setAttribute('data-en-ph', el.getAttribute('placeholder') || ''); });
  var langBtns = document.querySelectorAll('.lang button');

  /* Statement word split (re-run after language change) */
  var st = document.getElementById('statement'), words = [];
  function split(){
    var out = [];
    Array.prototype.slice.call(st.childNodes).forEach(function(n){
      var hl = n.nodeType === 1 && n.hasAttribute('data-hl');
      (n.textContent || '').split(/(\s+)/).forEach(function(t){
        if (!t) return;
        if (/^\s+$/.test(t)) { out.push(t); return; }
        out.push('<span class="w' + (hl ? ' hl' : '') + '">' + t + '</span>');
      });
    });
    st.innerHTML = out.join('');
    words = st.querySelectorAll('.w');
  }

  function setLang(l){
    lang = l;
    root.setAttribute('lang', l);
    root.setAttribute('dir', l === 'ar' ? 'rtl' : 'ltr');
    i18n.forEach(function(el){ el.innerHTML = el.getAttribute(l === 'ar' ? 'data-ar' : 'data-en'); });
    phs.forEach(function(el){ el.setAttribute('placeholder', el.getAttribute(l === 'ar' ? 'data-ar-ph' : 'data-en-ph')); });
    langBtns.forEach(function(b){ b.setAttribute('aria-pressed', b.getAttribute('data-lang') === l ? 'true' : 'false'); });
    split(); build(); onScroll();
    try { document.dispatchEvent(new CustomEvent('fm:lang', { detail: l })); } catch (e) {}
  }
  langBtns.forEach(function(b){ b.addEventListener('click', function(){ setLang(b.getAttribute('data-lang')); }); });

  /* ---------- Phone menu ---------- */
  var mbtn = document.getElementById('menu-btn'), mnav = document.getElementById('mnav');
  function setMenu(open){ mnav.hidden = !open; mbtn.setAttribute('aria-expanded', open ? 'true' : 'false'); mbtn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu'); }
  mbtn.addEventListener('click', function(){ setMenu(mnav.hidden); });
  mnav.addEventListener('click', function(e){ if (e.target.closest('a')) setMenu(false); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !mnav.hidden) { setMenu(false); mbtn.focus(); } });

  /* ---------- Floating WhatsApp hides at the contact section ---------- */
  var fab = document.getElementById('fab'), quote = document.getElementById('contact');
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function(es){ es.forEach(function(e){ fab.classList.toggle('away', e.isIntersecting); }); }, { threshold: .25 }).observe(quote);
  }

  /* ---------- Journey ---------- */
  var steps = Array.prototype.slice.call(document.querySelectorAll('.j-step'));
  var scenes = document.querySelectorAll('.scene');
  var jgrid = document.querySelector('.j-grid'), jvis = document.getElementById('jvis'), jnum = document.getElementById('jnum');
  var bid = document.getElementById('bid'), bidtime = document.getElementById('bidtime');
  var arc = document.getElementById('arc'), arcdot = document.getElementById('arcdot'), arcLen = 0;
  try { arcLen = arc.getTotalLength(); } catch (e) {}
  var jtrack = document.getElementById('jtrack');
  steps.forEach(function(s, k){ var t = document.createElement('span'); t.className = 'j-tick'; t.style.left = (k / (steps.length - 1) * 100) + '%'; t.style.setProperty('--k', (k / (steps.length - 1)).toFixed(4)); jtrack.insertBefore(t, jtrack.firstChild); });
  var ticks = Array.prototype.slice.call(jtrack.querySelectorAll('.j-tick')).reverse();
  var current = 0;
  /* Each picture plays its own short animation when its step becomes active.
     It no longer redraws the drawings on every scroll movement, which was the main cause of the lag. */
  var playId = 0, firstPlayed = false;
  function applyLp(i, lp){
    scenes[i].style.setProperty('--lp', lp.toFixed(3));
    if (i === 2) {
      var price = 9000 + Math.round(lp * 21) * 250;
      bid.textContent = '$' + price.toLocaleString('en-US');
      var secs = Math.max(0, Math.round(30 - lp * 30));
      bidtime.textContent = '00:' + (secs < 10 ? '0' : '') + secs;
    }
    if (i === 4 && arcLen) {
      var pt = arc.getPointAtLength(arcLen * lp);
      arcdot.setAttribute('cx', pt.x.toFixed(1)); arcdot.setAttribute('cy', pt.y.toFixed(1));
    }
  }
  function playScene(i){
    var my = ++playId;
    scenes.forEach(function(s, k){ if (k !== i) s.style.setProperty('--lp', '0'); });
    if (reduce) { applyLp(i, 1); return; }
    var t0 = null, dur = 1800;
    applyLp(i, 0);
    function tick(ts){
      if (my !== playId) return;
      if (!t0) t0 = ts;
      var k = Math.min(1, (ts - t0) / dur);
      applyLp(i, 1 - Math.pow(1 - k, 3));
      if (k < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }
  /* Scrolling drives the picture directly: the animation moves exactly as far as the page moves,
     with a light smoothing so it glides instead of jumping. */
  var scrubScene = -1, scrubShown = 0, scrubTarget = 0, scrubRaf = 0;
  function scrubTo(i, target){
    scrubTarget = target;
    if (i !== scrubScene || reduce) { scrubScene = i; scrubShown = target; applyLp(i, target); return; }
    if (!scrubRaf) scrubRaf = requestAnimationFrame(scrubStep);
  }
  function scrubStep(){
    scrubRaf = 0;
    var d = scrubTarget - scrubShown;
    scrubShown = Math.abs(d) < .002 ? scrubTarget : scrubShown + d * .35;
    applyLp(scrubScene, scrubShown);
    if (scrubShown !== scrubTarget) scrubRaf = requestAnimationFrame(scrubStep);
  }
  /* switching steps touches only the two steps and two pictures involved, with no forced re-layout */
  function setStep(i, noPlay){
    if (i === current) return;
    var prev = current; current = i;
    steps[prev].classList.remove('active'); steps[i].classList.add('active');
    scenes[prev].classList.remove('active'); scenes[i].classList.add('active');
    jnum.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
    if (jnum.animate && !reduce) jnum.animate([{ transform: 'translateY(16px)', opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: 400, easing: 'cubic-bezier(.2,.7,.1,1)' });
    if (!noPlay) playScene(i);
  }

  var heroEl = document.querySelector('.hero'), heroStage = document.getElementById('hero-stage'), heroCar = document.getElementById('hero-car'), hrLb = document.getElementById('hr-lb');
  var progEl = document.querySelector('.progress'), heroCopy = document.querySelector('.hero-copy');
  var marqueeTrack = document.querySelector('.marquee-track'), marqueeBox = marqueeTrack ? marqueeTrack.parentNode : null;
  var jSteps = document.querySelector('.j-steps'), jFill = document.querySelector('.j-fill'), jCar = document.querySelector('.j-car');
  var trackW = 0, heroH = 0, stickyTop = 0, heroTravel = 0, hrFill = document.querySelector('.hr-fill');
  var hrLine = document.getElementById('hr-line'), hrDot = document.querySelector('.hr-dot'), hrLineW = 0, dotStart = 0;
  /* true when the browser can link styles to scrolling itself (smoothest: runs in the graphics chip) */
  var cssScroll = !reduce && !!(window.CSS && CSS.supports && CSS.supports('animation-timeline: scroll()'));
  var phoneDrive = false; /* the car moves only while scrolling, on phones too */
  var cssJourney = cssScroll && CSS.supports('timeline-scope: --a') && CSS.supports('view-timeline-name: --a');
  var carFront = 4, jdPx = 1;
  function measure(){
    heroTravel = Math.max(0, heroStage.clientWidth - heroCar.offsetWidth);
    hrLineW = hrLine.clientWidth;
    /* where the car's centre sits on the route line before it starts moving */
    var sr = heroStage.getBoundingClientRect(), lr = hrLine.getBoundingClientRect();
    dotStart = heroCar.offsetLeft + heroCar.offsetWidth / 2 - (lr.left - sr.left);
    trackW = jtrack.getBoundingClientRect().width || jtrack.clientWidth; heroH = heroEl.offsetHeight;
    stickyTop = parseFloat(getComputedStyle(jvis).top) || 0;
    /* journey route: how far the page scrolls from step 1 to step 7, and the route width */
    var jd = 0; for (var si = 0; si < steps.length - 1; si++) jd += steps[si].offsetHeight;
    jdPx = jd; jgrid.style.setProperty('--jd', jd + 'px'); jgrid.style.setProperty('--tw', trackW + 'px');
    /* each dot lights when the front of the little car touches it (half the car's width before its centre) */
    carFront = 4;   // the blue line's tip touches a dot (8px wide) 4px before its centre
    ticks.forEach(function(t, k){ t.style.setProperty('--k', Math.max(0, k / (steps.length - 1) - carFront / Math.max(1, trackW)).toFixed(4)); });
    /* distances for the graphics-chip version of section 1 (see the hs* animations in the styles) */
    var lw = hrLineW || 1, d0 = Math.max(0, Math.min(hrLineW, dotStart)), d1 = Math.max(0, Math.min(hrLineW, dotStart - heroTravel));
    var hs = heroEl.style;
    hs.setProperty('--hh', heroH + 'px'); hs.setProperty('--hr', Math.round(heroH * .6) + 'px');
    hs.setProperty('--copyShift', (heroH * .12).toFixed(1) + 'px'); hs.setProperty('--travel', heroTravel.toFixed(1) + 'px');
    hs.setProperty('--d0', d0.toFixed(1) + 'px'); hs.setProperty('--d1', d1.toFixed(1) + 'px');
    hs.setProperty('--f0', (1 - d0 / lw).toFixed(4)); hs.setProperty('--f1', (1 - d1 / lw).toFixed(4));
  }
  measure();
  /* the route labels change width once the fonts arrive, so measure again then */
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function(){ measure(); onScroll(); });
  window.addEventListener('load', function(){ measure(); onScroll(); });
  var vh = window.innerHeight;
  window.addEventListener('resize', function(){ vh = window.innerHeight; measure(); onScroll(); });

  function clamp(x){ return Math.max(0, Math.min(1, x)); }
  var lastWords = -1, lastTicks = -1, heroOn = true;
  /* Reads all positions first, then writes, and only touches the elements that move.
     (Writing to the page root on every frame made the whole page restyle, which caused the lag.) */
  function onScroll(){
    var y = window.scrollY || window.pageYOffset;
    var max = document.documentElement.scrollHeight - vh;
    var r = st.getBoundingClientRect();
    var gr = jgrid.getBoundingClientRect();
    var nearJourney = gr.bottom > -vh * .5 && gr.top < vh * 1.5;
    var line = vh * .55, idx = current, sr = null;
    if (nearJourney) {
      /* the blue line's progress (same formula as the route animation), and the step whose dot it has reached:
         the picture switches at the exact moment the line touches the dot */
      var jpLine = clamp((line - jSteps.getBoundingClientRect().top) / Math.max(1, jdPx));
      var seg = Math.max(1, trackW / (steps.length - 1)), lineAt = (jpLine * trackW + carFront) / seg;
      idx = Math.min(steps.length - 1, Math.floor(lineAt + .001));
      sr = steps[idx].getBoundingClientRect();
      var visTop = jvis.getBoundingClientRect().top;
    }

    /* --- writes --- */
    if (!cssScroll) progEl.style.transform = 'scaleX(' + (max > 0 ? y / max : 0).toFixed(4) + ')';
    var heroVisible = y < heroH + 50;
    if (heroVisible || heroOn) {
      var hp = clamp(y / Math.max(1, heroH * .6));
      if (!phoneDrive) hrLb.classList.toggle('on', hp > .97);
      /* browsers without scroll-linked styles: move the car, dot, trail and text from here */
      if (!cssScroll && !phoneDrive) {
        heroCar.style.transform = 'translate3d(' + (-hp * heroTravel).toFixed(1) + 'px,0,0)';
        /* blue dot on the route marks where the car is (USA on the right, Lebanon on the left);
           the cyan trail runs from the USA end up to the dot */
        var dotX = Math.max(0, Math.min(hrLineW, dotStart - hp * heroTravel));
        hrDot.style.transform = 'translate3d(' + dotX.toFixed(1) + 'px,-50%,0)';
        hrFill.style.transform = 'scaleX(' + (hrLineW ? 1 - dotX / hrLineW : 0).toFixed(4) + ')';
      }
      /* headline and buttons drift a little as you scroll (phones included) */
      if (!cssScroll && !reduce) heroCopy.style.transform = 'translate3d(0,' + (Math.min(y, heroH) * .12).toFixed(1) + 'px,0)';
    }
    if (heroVisible && !heroOn) heroOn = true;
    if (!heroVisible) heroOn = false;

    var n = Math.round(clamp((vh * .85 - r.top) / (r.height + vh * .35)) * words.length);
    if (n !== lastWords) { for (var k = 0; k < words.length; k++) words[k].classList.toggle('on', k < n); lastWords = n; }

    if (nearJourney) {
      /* phones: only cover the gap above the picture once it is pinned, never the heading */
      jvis.classList.toggle('stuck', visTop <= stickyTop + 1 && gr.bottom > vh * .3);
      setStep(idx, true);
      /* the picture plays from one dot to the next; the last one plays through its own step */
      var lp = idx < steps.length - 1 ? clamp(lineAt - idx) : clamp((line - sr.top) / Math.max(1, sr.height));
      if (!drag) scrubTo(idx, lp);
      var jp = jpLine;
      /* route bar, little car and side bar: the graphics chip moves them where supported (see jr* styles) */
      if (!cssJourney) {
        jSteps.style.setProperty('--jp', jp.toFixed(4));
        jFill.style.transform = 'scaleX(' + jp.toFixed(4) + ')';
        jCar.style.transform = 'translateX(' + (jp * trackW).toFixed(1) + 'px) translateX(-50%)';
      }
      /* light each dot from the car's own position on the route, so dot and car always match */
      var litUpTo = Math.min(steps.length - 1, Math.floor((jp * trackW + carFront) / Math.max(1, trackW / (steps.length - 1)) + .001));
      if (litUpTo !== lastTicks) { ticks.forEach(function(t, k){ t.classList.toggle('on', k <= litUpTo); }); lastTicks = litUpTo; }

    }
  }
  var ticking = false;
  window.addEventListener('scroll', function(){ if (!ticking) { ticking = true; requestAnimationFrame(function(){ ticking = false; onScroll(); }); } }, { passive: true });

  /* Move through the journey by hand too: swipe or drag the picture, tap the arrows (phones),
     or tap a dot on the route. It scrolls the page to that step, so scrolling and swiping stay in sync. */
  function goStep(i){
    i = Math.max(0, Math.min(steps.length - 1, i));
    var r = steps[i].getBoundingClientRect(), y = window.scrollY || window.pageYOffset, top;
    /* lands most of the way to the next dot, so its picture plays through as the page glides there */
    if (i < steps.length - 1) top = y + jSteps.getBoundingClientRect().top - (vh * .55 - jdPx * (i + .85) / (steps.length - 1));
    else top = y + r.top - (vh * .55 - .85 * r.height);
    window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
  }
  var jnav = document.createElement('div');
  jnav.className = 'j-nav';
  jnav.innerHTML = '<button type="button" class="j-arrow" data-dir="-1">&#8249;</button><span class="j-hint"></span><button type="button" class="j-arrow" data-dir="1">&#8250;</button>';
  jvis.appendChild(jnav);
  var jArrows = jnav.querySelectorAll('.j-arrow'), jHint = jnav.querySelector('.j-hint');
  function navText(){
    var ar = root.getAttribute('lang') === 'ar';
    jHint.textContent = ar ? 'اسحب الصورة لليمين أو اليسار' : 'Swipe the picture left or right';
    jArrows[0].setAttribute('aria-label', ar ? 'المرحلة السابقة' : 'Previous step');
    jArrows[1].setAttribute('aria-label', ar ? 'المرحلة التالية' : 'Next step');
    ticks.forEach(function(t, k){ t.setAttribute('aria-label', (ar ? 'المرحلة ' : 'Step ') + (k + 1)); });
  }
  jnav.addEventListener('click', function(e){ var b = e.target.closest('.j-arrow'); if (b) goStep(current + (+b.getAttribute('data-dir'))); });
  ticks.forEach(function(t, k){
    t.setAttribute('role', 'button'); t.setAttribute('tabindex', '0');
    t.addEventListener('click', function(){ goStep(k); });
    t.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); goStep(k); } });
  });
  navText(); document.addEventListener('fm:lang', navText);
  /* Swipe the picture left or right: the page moves with your finger exactly like scrolling up and
     down, so the journey follows your finger at the same speed, stops when it stops, and goes back
     when you swipe back. A quick flick keeps gliding a little, like normal scrolling. */
  var drag = null, hDrag = null, glideId = 0, rootStyle = document.documentElement.style;
  function moveBy(px){ rootStyle.scrollBehavior = 'auto'; window.scrollBy(0, px); }
  function glide(v){
    var my = ++glideId, last = performance.now();
    function step(now){
      if (my !== glideId) return;
      var dt = Math.min(40, now - last); last = now;
      moveBy(v * dt);
      v *= Math.pow(.94, dt / 16.7);
      if (Math.abs(v) > .02) requestAnimationFrame(step); else rootStyle.scrollBehavior = '';
    }
    requestAnimationFrame(step);
  }
  function hStart(x, y){ glideId++; hDrag = { x: x, y: y, lastX: x, lastT: performance.now(), v: 0, axis: null }; }
  function hMove(x, y){
    if (!hDrag) return false;
    if (!hDrag.axis) {
      var ax = Math.abs(x - hDrag.x), ay = Math.abs(y - hDrag.y);
      if (ax < 6 && ay < 6) return false;
      hDrag.axis = ax > ay ? 'x' : 'y';
    }
    if (hDrag.axis !== 'x') return false;
    var dx = x - hDrag.lastX, now = performance.now(), dt = Math.max(1, now - hDrag.lastT);
    moveBy(-dx); /* finger left = forward, finger right = back */
    hDrag.v = .7 * (-dx / dt) + .3 * hDrag.v;
    hDrag.lastX = x; hDrag.lastT = now;
    return true;
  }
  function hEnd(){
    if (!hDrag) return;
    var d = hDrag; hDrag = null;
    if (d.axis === 'x' && !reduce && performance.now() - d.lastT < 90 && Math.abs(d.v) > .2) glide(d.v);
    else rootStyle.scrollBehavior = '';
  }
  jvis.addEventListener('touchstart', function(e){ if (e.touches.length === 1) hStart(e.touches[0].clientX, e.touches[0].clientY); else hDrag = null; }, { passive: true });
  jvis.addEventListener('touchmove', function(e){
    if (hDrag && e.touches.length === 1 && hMove(e.touches[0].clientX, e.touches[0].clientY) && e.cancelable) e.preventDefault();
  }, { passive: false });
  jvis.addEventListener('touchend', hEnd, { passive: true });
  jvis.addEventListener('touchcancel', function(){ hDrag = null; rootStyle.scrollBehavior = ''; }, { passive: true });
  /* mouse: click and drag the picture sideways */
  jvis.addEventListener('pointerdown', function(e){ if (e.pointerType === 'mouse' && !e.button) { hStart(e.clientX, e.clientY); e.preventDefault(); } });
  window.addEventListener('pointermove', function(e){ if (e.pointerType === 'mouse' && hDrag) hMove(e.clientX, e.clientY); });
  window.addEventListener('pointerup', function(e){ if (e.pointerType === 'mouse') hEnd(); });
  /* ---------- Bubbles: follow the pointer ---------- */
  document.querySelectorAll('.bub-face').forEach(function(f){
    f.addEventListener('pointermove', function(e){
      var b = f.getBoundingClientRect();
      f.style.setProperty('--mx', ((e.clientX - b.left - b.width / 2) * .18).toFixed(1) + 'px');
      f.style.setProperty('--my', ((e.clientY - b.top - b.height / 2) * .18).toFixed(1) + 'px');
    });
    f.addEventListener('pointerleave', function(){ f.style.setProperty('--mx', '0px'); f.style.setProperty('--my', '0px'); });
  });

  /* ---------- Counters ---------- */
  var years = new Date().getFullYear() - 2007;
  function runCounter(el){
    var target = el.getAttribute('data-count') === 'years' ? years : parseInt(el.getAttribute('data-count'), 10);
    var small = el.querySelector('small'); var suffix = small ? small.outerHTML : '';
    if (reduce) { el.innerHTML = target + suffix; return; }
    var t0 = null;
    function tick(t){ if (!t0) t0 = t; var k = Math.min(1, (t - t0) / 900); var e = 1 - Math.pow(1 - k, 2);
      el.innerHTML = Math.round(target * e) + suffix; if (k < 1) requestAnimationFrame(tick); }
    requestAnimationFrame(tick);
  }
  var counters = document.querySelectorAll('[data-count]');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting) { runCounter(e.target); io.unobserve(e.target); } }); }, { threshold: .5 });
    counters.forEach(function(c){ io.observe(c); });
  } else { counters.forEach(runCounter); }

  /* ---------- Hero light trails ----------
     Built once; after that the graphics chip moves them, so they stay smooth even while scrolling. */
  (function(){
    var box = document.getElementById('trails');
    if (!box) return;
    var n = window.innerWidth < 700 ? 12 : 20, html = '';
    for (var i = 0; i < n; i++) {
      var lane = Math.random(), len = 60 + Math.random() * 220, cyan = Math.random() < .55;
      var speed = 120 + lane * 360 + Math.random() * 120;            /* pixels per second */
      var dur = (Math.max(window.innerWidth, 360) + len * 2) / speed;
      html += '<i class="trail" style="top:' + (25 + lane * 70).toFixed(1) + '%;--len:' + len.toFixed(0) + 'px;--w:' + (.6 + lane * 1.6).toFixed(2) +
        'px;--c:' + (cyan ? '28,196,244' : '255,255,255') + ';--a:' + (.15 + lane * .45).toFixed(2) + ';--dur:' + dur.toFixed(2) + 's;--delay:-' + (Math.random() * dur).toFixed(2) + 's"></i>';
    }
    box.innerHTML = html;
  })();

  function build(){}
  var yr = document.getElementById('yr'); if (yr) yr.textContent = new Date().getFullYear();

  document.querySelectorAll('.copy').forEach(function(btn){
    btn.addEventListener('click', function(){
      function done(){ btn.textContent = lang === 'ar' ? 'تم النسخ' : 'Copied'; setTimeout(function(){ btn.textContent = lang === 'ar' ? 'نسخ' : 'Copy'; }, 1600); }
      function fallback(){ var r = document.createRange(); r.selectNodeContents(document.getElementById(btn.getAttribute('data-target')));
        var s = window.getSelection(); s.removeAllRanges(); s.addRange(r); btn.textContent = lang === 'ar' ? 'تم التحديد' : 'Selected'; }
      try { navigator.clipboard.writeText(btn.getAttribute('data-copy')).then(done, fallback); } catch (e) { fallback(); }
    });
  });

  /* ---------- Back to top ---------- */
  (function(){
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'totop';
    b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    function label(){ b.setAttribute('aria-label', document.documentElement.getAttribute('lang') === 'ar' ? 'العودة إلى الأعلى' : 'Back to top'); }
    label(); document.addEventListener('fm:lang', label);
    document.body.appendChild(b);
    b.addEventListener('click', function(){ window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
    var shown = false, tick = false;
    function check(){ tick = false; var on = (window.scrollY || window.pageYOffset) > window.innerHeight * .9; if (on !== shown) { shown = on; b.classList.toggle('on', on); } }
    window.addEventListener('scroll', function(){ if (!tick) { tick = true; requestAnimationFrame(check); } }, { passive: true });
    check();
  })();

  /* ---------- Start ---------- */
  var saved = location.hash === '#ar' ? 'ar' : 'en';
  if (saved === 'ar') setLang('ar'); else { split(); build(); onScroll(); }
})();
;
/* ---------- Car finder ----------
   Visitors search the cars listed on this site. On the hosted site the list comes from
   cars.json (edit that file to add your own cars). Each car marked "example": true shows an
   "Example" tag; remove the example cars once you add real ones.
   Optional later: with window.FM_LIVE_API and a paid data feed, real auction cars are listed. */
(function(){
  var root = document.documentElement;
  var H = 3600000, now = Date.now();
  var EXAMPLES = [
    { auction:'copart', lot:'48271936', year:2021, make:'Toyota', model:'RAV4', trim:'XLE', body:'suv', miles:38412, damage:'front', title:'salvage', city:'Dallas', state:'TX', bid:9250, hoursToSale:5, example:true, image:(window.FM_ASSETS || 'assets/') + 'car-rav4.jpg' },
    { auction:'iaa', lot:'39104527', year:2020, make:'Honda', model:'Accord', trim:'Sport', body:'sedan', miles:41980, damage:'rear', title:'clean', city:'Houston', state:'TX', bid:7600, hoursToSale:30, example:true, image:(window.FM_ASSETS || 'assets/') + 'car-accord.jpg' },
    { auction:'iaa', lot:'38877412', year:2019, make:'Ford', model:'F-150', trim:'XLT', body:'pickup', miles:64300, damage:'side', title:'salvage', city:'Phoenix', state:'AZ', bid:13400, hoursToSale:9, example:true, image:(window.FM_ASSETS || 'assets/') + 'car-f150.jpg' },
    { auction:'copart', lot:'50993348', year:2020, make:'BMW', model:'X5', trim:'xDrive40i', body:'suv', miles:51230, damage:'front', title:'salvage', city:'Chicago', state:'IL', bid:17800, hoursToSale:74, example:true, image:(window.FM_ASSETS || 'assets/') + 'car-x5.jpg' }
  ];
  /* Values typed in Shopify can vary ("IAAI", "SUV", "Salvage title", "Front End"):
     bring them to the names the search filters and labels use */
  var NORM = {
    auction: [['iaa', /^ia|insurance auto/], ['copart', /^cop/]],
    body: [['suv', /suv|crossover|sport utility/], ['pickup', /pick|truck/], ['coupe', /coupe|convertible|sports?$/], ['sedan', /sedan|saloon|hatch|wagon/]],
    title: [['salvage', /salv|rebuil|parts|junk|repair/], ['clean', /clean|clear/]],
    damage: [['front', /front/], ['rear', /rear|back/], ['side', /side/], ['hail', /hail/], ['water', /water|flood/], ['mechanical', /mech|engine|transmission/], ['minor', /minor|dent|scratch/]]
  };
  function normVal(kind, v){
    v = String(v == null ? '' : v).toLowerCase().trim();
    for (var i = 0; i < NORM[kind].length; i++) if (NORM[kind][i][1].test(v)) return NORM[kind][i][0];
    return v;
  }
  function prep(list){
    return list.map(function(c, i){
      var o = {}; for (var k in c) o[k] = c[k];
      /* sale time: a timestamp (Shopify sends one, so the store's timezone is respected) or a date text */
      o.saleAt = typeof c.saleAt === 'number' ? c.saleAt : c.saleAt ? (Date.parse(c.saleAt) || 0) : (c.hoursToSale ? now + c.hoursToSale * H : 0);
      o.lot = String(o.lot || ''); o.year = +o.year || ''; o.miles = +o.miles || 0; o.bid = +o.bid || 0;
      o.make = String(o.make || ''); o.model = String(o.model || ''); o.trim = String(o.trim || ''); o.city = String(o.city || ''); o.state = String(o.state || '');
      o.auction = normVal('auction', o.auction) || 'copart'; o.body = normVal('body', o.body); o.title = normVal('title', o.title); o.damage = normVal('damage', o.damage);
      o.uid = 'c' + i;   /* each car's own id, so "Details" opens the right car even when lot numbers repeat or are missing */
      return o;
    });
  }
  var CARS = prep(EXAMPLES);
  /* Tries each address in turn: the admin-saved list first, then cars.json, then the examples above */
  function loadCars(urls){
    if (!urls.length || !window.fetch) return Promise.resolve();
    return fetch(urls[0], { cache: 'no-cache' }).then(function(r){ if (!r.ok) throw new Error(); return r.json(); })
      .then(function(d){ var list = Array.isArray(d) ? d : d && d.cars; if (!Array.isArray(list)) throw new Error(); CARS = prep(list); })
      ['catch'](function(){ return loadCars(urls.slice(1)); });
  }
  var carsReady = Array.isArray(window.FM_CARS_DATA) ? (CARS = prep(window.FM_CARS_DATA), Promise.resolve()) : loadCars([].concat(window.FM_CARS_URL || []));

  function localSearch(p){
    var q = p.q.toLowerCase().split(/\s+/).filter(Boolean);
    var res = CARS.filter(function(c){
      var hay = (c.year + ' ' + c.make + ' ' + c.model + ' ' + c.trim + ' ' + c.lot + ' ' + c.city + ' ' + c.state + ' ' + c.body).toLowerCase();
      for (var i = 0; i < q.length; i++) if (hay.indexOf(q[i]) < 0) return false;
      if (p.auction && c.auction !== p.auction) return false;
      if (p.body && c.body !== p.body) return false;
      if (p.year && c.year < p.year) return false;
      if (p.bid && c.bid >= p.bid) return false;
      if (p.title && c.title !== p.title) return false;
      return true;
    });
    var key = { ending: function(a, b){ return (a.saleAt || 9e15) - (b.saleAt || 9e15); }, bid: function(a, b){ return a.bid - b.bid; },
                year: function(a, b){ return b.year - a.year || a.bid - b.bid; }, miles: function(a, b){ return a.miles - b.miles; } }[p.sort] || null;
    if (key) res.sort(key);
    return new Promise(function(resolve){ setTimeout(function(){ resolve({ results: res, live: false }); }, 180); });
  }

  var LIVE_API = window.FM_LIVE_API || null;
  var CarSource = {
    search: function(p){
      if (!LIVE_API || !window.fetch) return carsReady.then(function(){ return localSearch(p); });
      var qs = Object.keys(p).filter(function(k){ return p[k]; }).map(function(k){ return k + '=' + encodeURIComponent(p[k]); }).join('&');
      return fetch(LIVE_API + (qs ? '?' + qs : ''), { headers: { 'Accept': 'application/json' } })
        .then(function(r){ if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function(d){
          if (!d || !d.live || !d.results) throw new Error('not live');
          d.results.forEach(function(c){ c.saleAt = typeof c.saleAt === 'number' ? c.saleAt : (Date.parse(c.saleAt) || 0); });
          return d;
        })['catch'](function(){ return carsReady.then(function(){ return localSearch(p); }); });
    }
  };
  var T = {
    en: { example:'Example', cars:'cars', car:'car', found:'found', bid:'Current bid', ends:'Sale in', ended:'Sale started', details:'Details', request:'Request',
          mi:'mi', clean:'Clean title', salvage:'Salvage title', d:'d', h:'h', m:'m',
          damage:{ front:'Front end', rear:'Rear end', side:'Side', minor:'Minor dents', hail:'Hail', water:'Water / flood', mechanical:'Mechanical' },
          body:{ sedan:'Sedan', suv:'SUV', pickup:'Pickup', coupe:'Coupe' },
          fields:{ auction:'Auction', lot:'Lot number', year:'Year', miles:'Odometer', damage:'Primary damage', title:'Title', body:'Body', loc:'Location', sale:'Sale date' },
          note:'We check the Carfax history report before we bid on any car.', wa:'Request this car on WhatsApp', back:'Back to results',
          msg:function(c){ return 'Hi FM Motors, I am interested in this car:\n' + c.year + ' ' + c.make + ' ' + c.model + (c.trim ? ' ' + c.trim : '') + '\n' + label(c.auction) + ' lot ' + c.lot + ' (' + c.city + ', ' + c.state + ')\nCurrent bid: $' + money(c.bid); } },
    ar: { example:'مثال', cars:'سيارة', car:'سيارة', found:'', bid:'المزايدة الحالية', ends:'المزاد بعد', ended:'بدأ المزاد', details:'التفاصيل', request:'اطلبها',
          mi:'ميل', clean:'ملكية نظيفة', salvage:'سالفج', d:'ي', h:'س', m:'د',
          damage:{ front:'ضرر أمامي', rear:'ضرر خلفي', side:'ضرر جانبي', minor:'طعجات بسيطة', hail:'برَد', water:'غرق / مياه', mechanical:'ميكانيكي' },
          body:{ sedan:'سيدان', suv:'دفع رباعي', pickup:'بيك أب', coupe:'كوبيه' },
          fields:{ auction:'المزاد', lot:'رقم المزاد', year:'سنة الصنع', miles:'عدّاد المسافة', damage:'الضرر الأساسي', title:'الملكية', body:'النوع', loc:'الموقع', sale:'موعد المزاد' },
          note:'نتحقق من تقرير Carfax لتاريخ السيارة قبل المزايدة على أي سيارة.', wa:'اطلب هذه السيارة على واتساب', back:'العودة إلى النتائج',
          msg:function(c){ return 'مرحباً FM Motors، أنا مهتم بهذه السيارة:\n' + c.year + ' ' + c.make + ' ' + c.model + (c.trim ? ' ' + c.trim : '') + '\n' + label(c.auction) + ' رقم ' + c.lot + ' (' + c.city + ', ' + c.state + ')\nالمزايدة الحالية: $' + money(c.bid); } }
  };
  function L(){ return T[root.getAttribute('lang') === 'ar' ? 'ar' : 'en']; }
  function money(n){ return (+n || 0).toLocaleString('en-US'); }
  function label(a){ return a === 'copart' ? 'Copart' : a === 'iaa' ? 'IAA' : String(a || '').toUpperCase(); }
  function esc(s){ return String(s).replace(/[&<>"]/g, function(ch){ return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;' }[ch]; }); }
  function left(c){
    var t = L(), ms = c.saleAt - Date.now();
    if (!c.saleAt) return '—';   /* no sale date entered yet */
    if (ms <= 0) return t.ended;
    var d = Math.floor(ms / 864e5), h = Math.floor(ms % 864e5 / H), m = Math.floor(ms % H / 60000);
    return d > 0 ? d + t.d + ' ' + h + t.h : h > 0 ? h + t.h + ' ' + m + t.m : m + t.m;
  }
  function wa(c){ return 'https://wa.me/' + (window.FM_WA || '9613966677') + '?text=' + encodeURIComponent(L().msg(c)); }
  var logos = {};
  ['copart','iaa'].forEach(function(a){ var im = document.querySelector('img[alt="' + (a === 'copart' ? 'Copart' : 'IAA') + ' logo"]'); logos[a] = im ? im.getAttribute('src') : ''; });
  var cfxImg = document.querySelector('img.cfx');
  function art(c){
    if (c.image) return '<img class="photo" src="' + esc(c.image) + '" alt="" loading="lazy" decoding="async">';
    var s = c.body === 'suv' ? 'suv' : c.body === 'pickup' ? 'pickup' : 'car'; var vb = s === 'car' ? '0 0 200 70' : '0 0 200 80';
    return '<svg viewBox="' + vb + '" aria-hidden="true"><use href="#' + s + '"/></svg>'; }
  /* Live feeds may send values outside the known lists; show them as given. */
  function dmg(c){ return L().damage[c.damage] || esc(c.damage || '—'); }
  function ttl(c){ return L()[c.title] || esc(c.title || '—'); }
  function bdy(c){ return L().body[c.body] || esc(c.body || '—'); }

  var form = document.getElementById('finder'), grid = document.getElementById('f-grid'), count = document.getElementById('f-count');
  var empty = document.getElementById('f-empty'), moreBtn = document.getElementById('f-more');
  /* phones show 2 cars at a time, larger screens 8 ("Show more" loads the rest) */
  var PAGE = window.matchMedia && window.matchMedia('(max-width:600px)').matches ? 2 : 8;
  var results = [], shown = PAGE, reqId = 0, timer = null;

  function params(){
    return { q: document.getElementById('f-q').value.trim(), auction: document.getElementById('f-auction').value, body: document.getElementById('f-body').value,
             year: +document.getElementById('f-year').value, bid: +document.getElementById('f-bid').value, title: document.getElementById('f-title').value,
             sort: document.getElementById('f-sort').value };
  }
  function card(c, i){
    var t = L(), soon = !!c.saleAt && c.saleAt - Date.now() < 6 * H;
    return '<article class="car" style="--i:' + i + '">' +
      '<div class="car-art">' + art(c) + '<span class="chip"><img src="' + logos[c.auction] + '" alt="' + label(c.auction) + '"></span>' + '<span class="lot">LOT ' + esc(c.lot) + '</span></div>' +
      '<div class="car-body"><h3>' + esc(c.year) + ' ' + esc(c.make) + ' ' + esc(c.model) + (c.trim ? ' <small>' + esc(c.trim) + '</small>' : '') + '</h3>' +
      '<ul class="specs"><li>' + money(c.miles) + ' ' + t.mi + '</li><li>' + dmg(c) + '</li><li class="t-' + esc(c.title) + '">' + ttl(c) + '</li></ul>' +
      '<div class="loc"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 21s-7-6.2-7-11a7 7 0 0 1 14 0c0 4.8-7 11-7 11Z"/><circle cx="12" cy="10" r="2.5"/></svg><span dir="ltr">' + esc(c.city) + ', ' + esc(c.state) + '</span></div>' +
      '<div class="car-foot"><div><span class="label">' + t.bid + '</span><b>$' + money(c.bid) + '</b></div><div class="ends' + (soon ? ' soon' : '') + '"><span class="label">' + t.ends + '</span><b data-left="' + esc(c.uid) + '">' + left(c) + '</b></div></div>' +
      '<div class="car-actions"><button class="btn btn-sm" type="button" data-detail="' + esc(c.uid) + '">' + t.details + '</button><a class="btn btn-sm btn-ac" href="' + wa(c) + '" target="_blank" rel="noopener">' + t.request + '</a></div>' +
      '</div></article>';
  }
  function render(){
    var t = L(), n = results.length;
    count.innerHTML = root.getAttribute('lang') === 'ar' ? '<b>' + n + '</b> ' + t.cars : '<b>' + n + '</b> ' + (n === 1 ? t.car : t.cars) + ' ' + t.found;
    grid.innerHTML = results.slice(0, shown).map(card).join('');
    empty.hidden = n > 0;
    moreBtn.hidden = n <= shown;
  }
  function run(){
    var p = params(), id = ++reqId;
    grid.innerHTML = '<div class="skel"></div><div class="skel"></div><div class="skel"></div><div class="skel"></div>';
    CarSource.search(p).then(function(r){ if (id !== reqId) return; results = r.results; shown = PAGE; render(); });
  }
  form.addEventListener('input', function(e){ clearTimeout(timer); timer = setTimeout(run, e.target.id === 'f-q' ? 250 : 0); });
  form.addEventListener('submit', function(e){ e.preventDefault(); clearTimeout(timer); run(); });
  moreBtn.addEventListener('click', function(){ shown += PAGE; render(); });
  setInterval(function(){
    grid.querySelectorAll('[data-left]').forEach(function(el){ var c = find(el.getAttribute('data-left')); if (c) el.textContent = left(c); });
  }, 30000);

  /* Detail dialog */
  var dlg = document.getElementById('car-dlg');
  function find(uid){ for (var i = 0; i < results.length; i++) if (results[i].uid === uid) return results[i]; return null; }
  var dlgLink = document.createElement('a');
  dlgLink.className = 'btn'; dlgLink.target = '_blank'; dlgLink.rel = 'noopener';
  document.querySelector('.dlg-actions').insertBefore(dlgLink, document.getElementById('dlg-back'));
  function openCar(c){
    var t = L(), f = t.fields;
    document.getElementById('dlg-art').innerHTML = art(c);
    document.getElementById('dlg-lot').textContent = label(c.auction) + ' · LOT ' + c.lot;
    document.getElementById('dlg-title').textContent = c.year + ' ' + c.make + ' ' + c.model + (c.trim ? ' ' + c.trim : '');
    var rows = [[f.auction, esc(label(c.auction))], [f.lot, esc(c.lot)], [f.year, esc(c.year)], [f.miles, money(c.miles) + ' ' + t.mi], [f.damage, dmg(c)],
                [f.title, ttl(c)], [f.body, bdy(c)], [f.loc, esc(c.city + ', ' + c.state)], [f.sale, c.saleAt ? esc(new Date(c.saleAt).toLocaleString(root.getAttribute('lang') === 'ar' ? 'ar-LB' : 'en-US', { weekday:'short', month:'short', day:'numeric', hour:'numeric', minute:'2-digit' })) : '—']];
    document.getElementById('dlg-grid').innerHTML = rows.map(function(r){ return '<div><dt class="label">' + r[0] + '</dt><dd>' + r[1] + '</dd></div>'; }).join('');
    dlgLink.hidden = !c.url;
    if (c.url) { dlgLink.href = c.url; dlgLink.textContent = (root.getAttribute('lang') === 'ar' ? 'عرض على ' : 'View on ') + label(c.auction) + ' ↗'; }
    document.getElementById('dlg-bid-l').textContent = t.bid; document.getElementById('dlg-bid').textContent = '$' + money(c.bid);
    document.getElementById('dlg-end-l').textContent = t.ends; document.getElementById('dlg-end').textContent = left(c);
    document.getElementById('dlg-note').textContent = t.note;
    if (cfxImg) document.getElementById('dlg-cfx').src = cfxImg.getAttribute('src');
    var w = document.getElementById('dlg-wa'); w.textContent = t.wa; w.href = wa(c);
    document.getElementById('dlg-back').textContent = t.back;
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
  }
  function closeDlg(){ if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); }
  grid.addEventListener('click', function(e){ var b = e.target.closest('[data-detail]'); if (b) { var c = find(b.getAttribute('data-detail')); if (c) openCar(c); } });
  document.getElementById('dlg-close').addEventListener('click', closeDlg);
  document.getElementById('dlg-back').addEventListener('click', closeDlg);
  dlg.addEventListener('click', function(e){ if (e.target === dlg) closeDlg(); });

  /* "Can't find it?" lot-number request */
  var lotIn = document.getElementById('lot-in'), lotWa = document.getElementById('lot-wa');
  function lotLink(){
    var v = lotIn.value.trim(), ar = root.getAttribute('lang') === 'ar';
    var msg = ar ? 'مرحباً FM Motors، أبحث عن هذه السيارة:' : 'Hi FM Motors, I am looking for this car:';
    lotWa.href = 'https://wa.me/' + (window.FM_WA || '9613966677') + '?text=' + encodeURIComponent(v ? msg + '\n' + v : msg);
  }
  lotIn.addEventListener('input', lotLink);
  lotLink();
  document.addEventListener('fm:lang', function(){ render(); lotLink(); if (dlg.open) closeDlg(); });
  run();
})();
;
/* ---------- Carfax request + shipment tracking ---------- */
(function(){
  var root = document.documentElement;
  function ar(){ return root.getAttribute('lang') === 'ar'; }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(ch){ return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;' }[ch]; }); }
  var WA = 'https://wa.me/' + (window.FM_WA || '9613966677') + '?text=';

  /* ----- Carfax request ----- */
  var vin = document.getElementById('cfx-vin'), vinCount = document.getElementById('vin-count'), vinMsg = document.getElementById('vin-msg');
  var cfxName = document.getElementById('cfx-name'), cfxSend = document.getElementById('cfx-send');
  var vinHelp = { en: vinMsg.getAttribute('data-en') || vinMsg.innerHTML, ar: vinMsg.getAttribute('data-ar') };
  function vinState(){
    var v = vin.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (vin.value !== v) vin.value = v;
    vinCount.textContent = v.length + '/17';
    var bad = /[IOQ]/.test(v), ok = v.length === 17 && !bad;
    vinCount.classList.toggle('ok', ok);
    vinMsg.className = 'vin-msg' + (bad ? ' err' : ok ? ' ok' : '');
    vinMsg.textContent = bad ? (ar() ? 'رقم الشاسيه لا يحتوي على الأحرف I أو O أو Q. تأكد من الرقم.' : 'A VIN never contains the letters I, O or Q. Check the number.')
      : ok ? (ar() ? 'رقم الشاسيه صحيح.' : 'VIN looks right.')
      : (ar() ? vinHelp.ar : vinHelp.en);
    var name = cfxName.value.trim();
    var msg = ar()
      ? 'مرحباً FM Motors، أريد تقرير Carfax بـ 5$.\nرقم الشاسيه: ' + v + (name ? '\nالاسم: ' + name : '')
      : 'Hi FM Motors, I would like a Carfax report ($5).\nVIN: ' + v + (name ? '\nName: ' + name : '');
    cfxSend.href = WA + encodeURIComponent(msg);
    return ok;
  }
  vin.addEventListener('input', vinState);
  cfxName.addEventListener('input', vinState);
  cfxSend.addEventListener('click', function(e){
    if (!vinState()) {
      e.preventDefault();
      vinMsg.className = 'vin-msg err';
      vinMsg.textContent = ar() ? 'أدخل رقم الشاسيه كاملاً (17 خانة) أولاً.' : 'Enter the full 17-character VIN first.';
      vin.focus();
    }
  });
  document.getElementById('cfx-form').addEventListener('submit', function(e){ e.preventDefault(); });
  vinState();

  /* ----- Shipment tracking ----- */
  var D = 864e5, now = Date.now();
  function day(offset){ return new Date(now + offset * D).toISOString().slice(0, 10); }
  /* Example shipments, so visitors can see how tracking works. Real shipments come from the
     server (window.FM_TRACK_API) on the hosted site; see README. */
  var DEMO = {
    'FM-24817': { car:'2021 Toyota RAV4 XLE', auction:'Copart', lot:'48271936', vin:'4A7731', step:4, demo:true,
                  dates:[day(-24), day(-20), day(-15), day(-11)], eta:day(16), vessel:'MSC Mediterranean 042E', container:'MSCU 482190-7' },
    'FM-31562': { car:'2020 Honda Accord Sport', auction:'IAA', lot:'39104527', vin:'C08214', step:6, demo:true,
                  dates:[day(-41), day(-37), day(-33), day(-29), day(-4), day(-1)], eta:day(3), vessel:'Example Vessel 017E', container:'ABCU 317702-2' },
    'FM-19034': { car:'2019 Lexus RX 350', auction:'Copart', lot:'49127766', vin:'115930', step:7, demo:true,
                  dates:[day(-58), day(-55), day(-50), day(-46), day(-21), day(-16), day(-12)], eta:day(-12), vessel:'Example Vessel 009E', container:'ABCU 190344-5' }
  };
  var STEPS = {
    en: ['Won at auction', 'Picked up from the yard', 'At the US port', 'On the ship', 'Arrived in Beirut', 'Customs cleared', 'Delivered'],
    ar: ['رُبحت في المزاد', 'استُلمت من الساحة', 'في المرفأ الأميركي', 'على متن الباخرة', 'وصلت إلى بيروت', 'تم التخليص الجمركي', 'تم التسليم']
  };
  var form = document.getElementById('trk-form'), input = document.getElementById('trk-code'), out = document.getElementById('trk-out');
  var last = null;

  function norm(v){
    var s = String(v || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (/^\d{4,}$/.test(s)) s = 'FM' + s;
    return s.replace(/^FM(?=\d)/, 'FM-');
  }
  function fmtDate(iso){
    var d = new Date(iso + (iso.length === 10 ? 'T12:00:00' : ''));
    if (isNaN(d)) return '';
    return d.toLocaleDateString(ar() ? 'ar-LB' : 'en-US', { month:'short', day:'numeric' });
  }
  function lookup(code){
    /* Shopify: each shipment is a "Shipment" entry (Content → Metaobjects). Its page,
       /pages/shipment/fm-24817, holds the details in an "fm-shipment" block (templates/metaobject/shipment.liquid). */
    if (window.FM_TRACK_SHOPIFY && window.fetch) {
      var base = String(window.FM_ROOT || '/').replace(/\/?$/, '/');
      /* the entry's handle is normally "fm-24817"; also try "fm24817" in case it was typed without the dash */
      var handles = [code.toLowerCase(), code.toLowerCase().replace(/-/g, '')];
      var tryHandle = function(i){
        if (i >= handles.length) return null;
        return fetch(base + 'pages/shipment/' + encodeURIComponent(handles[i]), { credentials: 'same-origin' })
          .then(function(r){
            if (r.status === 404) return tryHandle(i + 1);
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.text().then(function(t){
              var m = /<script[^>]*id="fm-shipment"[^>]*>([\s\S]*?)<\/script>/.exec(t);
              if (!m) return tryHandle(i + 1);
              var s = (JSON.parse(m[1]) || {}).shipment;
              if (!s || !s.car) return null;
              /* no step set: use the last step that has a date */
              if (!(+s.step)) { var n = 0; (s.dates || []).forEach(function(x, k){ if (x) n = k + 1; }); s.step = n || 1; }
              return s;
            });
          });
      };
      return Promise.resolve(tryHandle(0));
    }
    var api = window.FM_TRACK_API;
    if (!api || !window.fetch) return Promise.resolve(null);
    return fetch(api + '?code=' + encodeURIComponent(code), { headers: { 'Accept': 'application/json' } })
      .then(function(r){ if (r.status === 404) return null; if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function(d){ return d && d.shipment ? d.shipment : null; });
  }
  /* Automatic container tracking (optional, window.FM_CONTAINER_API = the container connector, see fm-container-worker).
     Fills in the sea part of the trip by itself: at the US port, on the ship, arrived in Beirut, and the ship's name.
     It only ever moves a shipment forward, and waits at most 8 seconds; otherwise your own dates are shown. */
  function withContainer(code, s){
    var api = window.FM_CONTAINER_API;
    if (!s || s.demo || !api || !s.container || !window.fetch) return Promise.resolve(s);
    var live = fetch(api + (api.indexOf('?') < 0 ? '?' : '&') + 'code=' + encodeURIComponent(code), { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.ok ? r.json() : null; })['catch'](function(){ return null; });
    var wait = new Promise(function(res){ setTimeout(function(){ res(null); }, 8000); });
    return Promise.race([live, wait]).then(function(c){ return mergeContainer(s, c); });
  }
  function mergeContainer(s, c){
    if (!c || !c.live) return s;
    var o = {}, k; for (k in s) o[k] = s[k];
    var dates = (s.dates || []).slice(); while (dates.length < 7) dates.push(null);
    var step = Math.max(1, +s.step || 1);
    if (c.atPort) { if (!dates[2]) dates[2] = c.atPort; step = Math.max(step, 3); }
    if (c.shipped) { if (!dates[3]) dates[3] = c.shipped; step = Math.max(step, 4); }
    if (c.arrived) { if (!dates[4]) dates[4] = c.arrived; step = Math.max(step, 5); }
    o.dates = dates; o.step = step;
    if (c.vessel) o.vessel = c.vessel + (c.voyage ? ' ' + c.voyage : '');
    if (c.portEta) o.portEta = c.portEta;
    return o;
  }
  function message(html){ out.innerHTML = '<div class="trk-msg">' + html + '</div>'; }

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* Where each step sits along the route (0 = auction yard, 1 = customer's door) */
  var STOPS = [0, .07, .15, .5, .85, .92, 1];
  var animId = 0;
  function routeTarget(s, step){
    if (step >= 7) return 1;
    if (step === 4) {
      /* On the ship: place it by sailing time, from the US port date to about 10 days before delivery */
      /* the ship's own arrival estimate when container tracking gives one, else about 10 days before delivery */
      var dep = Date.parse((s.dates || [])[3] || ''), arr = s.portEta ? Date.parse(s.portEta) : s.eta ? Date.parse(s.eta) - 10 * D : NaN;
      if (dep && arr && arr > dep) {
        var k = Math.max(.06, Math.min(.94, (Date.now() - dep) / (arr - dep)));
        return STOPS[2] + (STOPS[4] - STOPS[2]) * k;
      }
    }
    return STOPS[step - 1];
  }
  function ease(t){ return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

  /* Container numbers open this site's own container tracking page (/pages/container-tracking),
     which shows live data from the shipping lines for free. Nothing opens on another website. */
  function carrierLink(container){
    var n = String(container || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (!/^[A-Z]{4}\d{7}$/.test(n) || !window.FM_CONTAINER_PAGE) return null;
    return { n: n, url: window.FM_CONTAINER_PAGE + '?c=' + n + (ar() ? '&lang=ar' : '') };
  }
  function openContainer(container){
    var cl = carrierLink(container);
    if (cl) location.href = cl.url;
    return cl;
  }

  function render(code, s){
    last = { code: code, s: s };
    var A = ar(), names = STEPS[A ? 'ar' : 'en'], n = names.length, step = Math.max(1, Math.min(n, +s.step || 1));
    var delivered = step >= n, dates = s.dates || [];
    var daysLeft = !delivered && s.eta ? Math.max(0, Math.ceil((new Date(s.eta + 'T12:00:00') - Date.now()) / D)) : 0;
    var etaLabel = delivered ? (A ? 'تاريخ التسليم' : 'Delivered on') : (A ? 'الوصول المتوقع' : 'Estimated delivery');
    var etaVal = delivered ? fmtDate(dates[n - 1] || s.eta || '') : (s.eta ? fmtDate(s.eta) : '—');
    var target = routeTarget(s, step);
    var onShip = step === 4;
    var items = names.map(function(name, i){
      var k = i + 1, cls = k < step || delivered ? 'done' : k === step ? 'now' : '';
      var when = dates[i] ? fmtDate(dates[i]) : (k === step ? (A ? 'الآن' : 'Now') : '');
      return '<li class="' + cls + '" style="--k:' + i + '"><span class="trk-dot"></span><b>' + name + '</b><small>' + esc(when) + '</small></li>';
    }).join('');
    /* the container number links to the shipping line's own free tracking page */
    var cnt = s.container ? (A ? 'الحاوية ' : 'Container ') + s.container : '', cl = s.container ? carrierLink(s.container, s.line) : null;
    var cntHtml = cnt && cl ? '<a class="trk-cnt" href="' + esc(cl.url) + '" title="' + (A ? 'تتبّع الحاوية مباشرة' : 'Track this container live') + '">' + esc(cnt) + ' →</a>' : esc(cnt);
    var meta = [esc(s.auction && s.lot ? s.auction + ' lot ' + s.lot : ''), esc(s.vin ? 'VIN …' + s.vin : ''), cntHtml, esc(s.vessel ? (A ? 'الباخرة ' : 'Vessel ') + s.vessel : '')].filter(Boolean).join(' · ');
    var ask = A ? 'مرحباً FM Motors، لدي سؤال عن شحنتي ' + code + ' (' + s.car + ').' : 'Hi FM Motors, I have a question about my shipment ' + code + ' (' + s.car + ').';
    var veh = onShip
      ? '<circle class="pulse" r="20" fill="#1CC4F4"/><g class="veh-in"><path d="M-22 3 L22 3 L16 12 L-16 12 Z" fill="#1CC4F4"/><rect x="-13" y="-7" width="8" height="10" fill="#1CC4F4"/><rect x="-4" y="-7" width="8" height="10" fill="#1CC4F4" opacity=".7"/><rect x="5" y="-3" width="10" height="6" fill="#1CC4F4"/></g>'
      : '<circle class="pulse" r="20" fill="#1CC4F4"/><g class="veh-in"><use href="#minicar" x="-24" y="-10" width="48" height="17"/></g>';
    out.innerHTML =
      '<article class="trk-card" id="trk-card">' +
        '<div class="trk-head"><div><span class="label ac">' + esc(code) + '</span>' +
          '<h3>' + esc(s.car) + '</h3><div class="trk-meta">' + meta + '</div></div>' +
          '<div class="trk-eta"><span class="trk-pill' + (delivered ? ' done' : '') + '">' + names[step - 1] + '</span>' +
          '<div style="margin-top:14px"><span class="label">' + etaLabel + '</span><b>' + esc(etaVal) + '</b></div></div></div>' +
        '<div class="trk-map"><svg class="trk-svg" viewBox="0 0 800 250" role="img" aria-label="' + (A ? 'مسار السيارة من أميركا إلى لبنان' : 'Route of the car from the USA to Lebanon') + '">' +
          '<defs><pattern id="trk-dots" width="18" height="18" patternUnits="userSpaceOnUse"><circle cx="2" cy="2" r="1" fill="#1F2228"/></pattern></defs>' +
          '<rect width="800" height="250" fill="url(#trk-dots)"/>' +
          '<path class="land" d="M0 40 Q70 50 96 110 Q118 168 76 250 L0 250 Z"/>' +
          '<path class="land" d="M800 30 Q748 60 736 112 Q728 160 768 250 L800 250 Z"/>' +
          '<text class="svgt sea" x="270" y="222" font-size="11" letter-spacing="' + (A ? 0 : 4) + '">' + (A ? 'المحيط الأطلسي' : 'ATLANTIC OCEAN') + '</text>' +
          '<text class="svgt sea" x="560" y="214" font-size="11" letter-spacing="' + (A ? 0 : 4) + '">' + (A ? 'البحر المتوسط' : 'MEDITERRANEAN') + '</text>' +
          '<path id="trk-bg" class="trk-path-bg" d="M64 150 C 230 30, 420 240, 600 128 S 712 96, 744 116"/>' +
          '<path id="trk-fg" class="trk-path-fg" d="M64 150 C 230 30, 420 240, 600 128 S 712 96, 744 116"/>' +
          '<g id="trk-nodes"></g>' +
          '<text class="svgt place" x="40" y="186" font-size="12">' + (A ? 'أميركا' : 'USA') + '</text>' +
          '<text class="svgt place" x="700" y="150" font-size="12">' + (A ? 'بيروت' : 'BEIRUT') + '</text>' +
          '<g id="trk-veh" transform="translate(64 150)">' + veh + '</g>' +
        '</svg></div>' +
        '<div class="trk-stats">' +
          '<div><span class="label">' + (A ? 'التقدّم' : 'Progress') + '</span><b id="st-pct">0%</b></div>' +
          '<div><span class="label">' + (A ? 'المرحلة' : 'Step') + '</span><b>' + step + '<small> / ' + n + '</small></b></div>' +
          '<div><span class="label">' + (delivered ? (A ? 'الحالة' : 'Status') : (A ? 'أيام حتى التسليم' : 'Days to delivery')) + '</span><b id="st-days">' + (delivered ? '✓' : '0') + '</b></div>' +
        '</div>' +
        '<ol class="trk-steps">' + items + '</ol>' +
        '<div class="trk-foot"><span>' + (s.note ? esc(s.note) : (A ? 'نحدّث حالة الشحنة عند كل مرحلة.' : 'We update your shipment at every step.')) + '</span>' +
          '<a class="btn btn-sm btn-ac" href="' + WA + encodeURIComponent(ask) + '" target="_blank" rel="noopener">' + (A ? 'اسألنا عن شحنتك' : 'Ask about this shipment') + '</a></div>' +
      '</article>';

    var card = document.getElementById('trk-card'), fg = document.getElementById('trk-fg'), bg = document.getElementById('trk-bg');
    var vehEl = document.getElementById('trk-veh'), nodesEl = document.getElementById('trk-nodes');
    var pctEl = document.getElementById('st-pct'), daysEl = document.getElementById('st-days');
    var L = 0; try { L = fg.getTotalLength(); } catch (e) {}
    var nodes = STOPS.map(function(t){
      var p = L ? fg.getPointAtLength(L * t) : { x: 64, y: 150 };
      var c = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      c.setAttribute('cx', p.x.toFixed(1)); c.setAttribute('cy', p.y.toFixed(1)); c.setAttribute('r', '6'); c.setAttribute('class', 'node');
      nodesEl.appendChild(c); return c;
    });
    if (L) { fg.style.strokeDasharray = L; fg.style.strokeDashoffset = L; }
    var pctTarget = Math.round(target * 100);

    /* The route's points are measured once here; moving the ship then costs almost nothing per frame
       (measuring the curve on every frame was the expensive part while scrolling). */
    var N = 400, PTS = [];
    if (L) for (var pi = 0; pi <= N; pi++) { var pp = fg.getPointAtLength(L * pi / N); PTS.push(pp.x, pp.y); }
    function at(t){
      if (!L) return { x: 64, y: 150 };
      var f = Math.max(0, Math.min(1, t)) * N, i = Math.min(N - 1, Math.floor(f)), r = f - i;
      return { x: PTS[2 * i] + (PTS[2 * i + 2] - PTS[2 * i]) * r, y: PTS[2 * i + 1] + (PTS[2 * i + 3] - PTS[2 * i + 1]) * r };
    }
    /* only write what changed since the last frame */
    var wT = '', wOff = '', wPct = '', wDays = '', wNodes = -1;
    function frame(t){
      var p = at(t), q = L ? at(t + 2 / L) : p;
      var ang = Math.max(-12, Math.min(12, Math.atan2(q.y - p.y, q.x - p.x) * 180 / Math.PI));
      var tr = 'translate(' + p.x.toFixed(1) + ' ' + p.y.toFixed(1) + ') rotate(' + ang.toFixed(1) + ')';
      if (tr !== wT) { vehEl.setAttribute('transform', tr); wT = tr; }
      if (L) { var off = (L * (1 - t)).toFixed(1); if (off !== wOff) { fg.style.strokeDashoffset = off; wOff = off; } }
      var lit = 0; for (var ni = 0; ni < STOPS.length; ni++) if (STOPS[ni] <= t + .001) lit = ni + 1;
      if (lit !== wNodes) { nodes.forEach(function(nd, i){ nd.classList.toggle('on', i < lit); }); wNodes = lit; }
      var k = target ? t / target : 1;
      var pc = Math.round(pctTarget * k) + '%'; if (pc !== wPct) { pctEl.textContent = pc; wPct = pc; }
      if (!delivered) { var dl = String(Math.round(daysLeft * k)); if (dl !== wDays) { daysEl.textContent = dl; wDays = dl; } }
    }
    var my = ++animId, inner = vehEl.querySelector('.veh-in'), playing = false;
    frame(0);

    /* Plays the trip each time the card scrolls into view, then keeps the vehicle moving gently */
    function play(){
      if (playing) return; playing = true;
      card.classList.remove('go'); void card.offsetWidth;
      requestAnimationFrame(function(){ card.classList.add('go'); });
      if (reduceMotion || !target) { frame(target); inner.classList.add('bob'); return; }
      inner.classList.remove('bob');
      var t0 = null, dur = 1600 + target * 1600;
      function tick(ts){
        if (my !== animId || !playing) return;
        if (!t0) t0 = ts;
        var k = Math.min(1, (ts - t0) / dur);
        frame(target * ease(k));
        if (k < 1) { requestAnimationFrame(tick); return; }
        inner.classList.add('bob');
        if (onShip) requestAnimationFrame(drift);
      }
      /* At sea the ship keeps sailing a little back and forth around today's position */
      var d0 = null, dLast = 0;
      function drift(ts){
        if (my !== animId || !playing) return;
        if (!d0) d0 = ts;
        /* this movement is very slow, so 30 updates a second look the same as 60 at half the work */
        if (ts - dLast >= 32) { dLast = ts; frame(Math.max(0, Math.min(1, target + Math.sin((ts - d0) / 1400) * .012))); }
        requestAnimationFrame(drift);
      }
      requestAnimationFrame(tick);
    }
    function reset(){ playing = false; card.classList.remove('go'); inner.classList.remove('bob'); frame(0); }

    /* Watch the map, not the whole card: the card can be taller than the screen.
       Plays when the map's middle is on screen, resets once the map is fully off screen. */
    var mapEl = card.querySelector('.trk-map');
    trkCheck = function(){
      var r = mapEl.getBoundingClientRect(), vh = window.innerHeight || document.documentElement.clientHeight;
      var mid = r.top + r.height / 2;
      if (mid > 0 && mid < vh) play();
      else if (r.bottom < 0 || r.top > vh) reset();
    };
    trkCheck();
  }
  var trkCheck = function(){};
  var trkTick = false;
  window.addEventListener('scroll', function(){
    if (trkTick) return; trkTick = true;
    setTimeout(function(){ trkTick = false; trkCheck(); }, 60);
  }, { passive: true });
  window.addEventListener('resize', function(){ trkCheck(); });

  function track(raw){
    /* a container number (4 letters + 7 digits): open this site's container tracking page */
    var cn = String(raw || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (/^[A-Z]{4}\d{7}$/.test(cn)) {
      var A = ar(); last = null; input.value = cn;
      if (openContainer(cn)) { out.innerHTML = '<div class="trk-msg trk-load"><span></span>' + (A ? 'جارٍ فتح تتبّع الحاوية…' : 'Opening container tracking…') + '</div>'; return; }
      var askC = A ? 'مرحباً FM Motors، أريد تتبّع الحاوية ' + cn + '.' : 'Hi FM Motors, I would like to track container ' + cn + '.';
      message((A ? 'لتتبّع الحاوية <b>' + esc(cn) + '</b> ' : 'To track container <b>' + esc(cn) + '</b>, ') +
        '<a href="' + WA + encodeURIComponent(askC) + '" target="_blank" rel="noopener" style="color:var(--accent)">' + (A ? 'راسلنا على واتساب' : 'message us on WhatsApp') + '</a>' +
        '.');
      return;
    }
    var code = norm(raw);
    if (!/^FM-\d{4,}$/.test(code)) { message(ar() ? 'أدخل رقم الحاوية من رسالتنا: 4 أحرف و7 أرقام، مثل MSCU1234567.' : 'Enter the container number from our message: 4 letters and 7 digits, like MSCU1234567.'); return; }
    input.value = code;
    out.innerHTML = '<div class="trk-msg trk-load"><span></span>' + (ar() ? 'جارٍ البحث عن شحنتك…' : 'Looking up your shipment…') + '</div>';
    var started = Date.now();
    lookup(code).then(function(s){ return withContainer(code, s); }).then(function(s){ return new Promise(function(res){ setTimeout(function(){ res(s); }, Math.max(0, 650 - (Date.now() - started))); }); }).then(function(s){
      if (s) { render(code, s); return; }
      last = null;
      var ask = ar() ? 'مرحباً FM Motors، لم أجد شحنتي برمز ' + code + '.' : 'Hi FM Motors, I could not find my shipment with code ' + code + '.';
      message((ar() ? 'لم نجد شحنة بالرمز <b>' + esc(code) + '</b>. تأكد من الرمز في رسالتنا، أو ' : 'No shipment found for <b>' + esc(code) + '</b>. Check the code in our message, or ') +
        '<a href="' + WA + encodeURIComponent(ask) + '" target="_blank" rel="noopener" style="color:var(--accent)">' + (ar() ? 'راسلنا على واتساب' : 'message us on WhatsApp') + '</a>.');
    })['catch'](function(){
      message(ar() ? 'تعذّر الاتصال الآن. حاول مجدداً بعد قليل.' : 'Could not check right now. Please try again in a moment.');
    });
  }
  form.addEventListener('submit', function(e){ e.preventDefault(); track(input.value); });
  document.querySelectorAll('.trk-demo button').forEach(function(b){ b.addEventListener('click', function(){ track(b.getAttribute('data-code')); }); });
  document.addEventListener('fm:lang', function(){ vinState(); if (last) render(last.code, last.s); });

  /* the animated tracking card shown on load, so the section always shows how tracking looks */
  render('MSCU4821907', DEMO['FM-24817']);
  /* a tracking link (yourdomain.com/#FM-24817) opens straight on the customer's shipment */
  if (location.hash && /^#[A-Z]{4}\d{7}$/i.test(location.hash)) openContainer(location.hash.slice(1));
  else if (location.hash && /^#FM-?\d+$/i.test(location.hash)) {
    track(location.hash.slice(1));
    var trkSec = document.getElementById('track');
    if (trkSec) setTimeout(function(){ trkSec.scrollIntoView({ block: 'start' }); }, 60);
  }
})();
;
/* ---------- Scroll reveal, pausing, smooth-scroll helpers ---------- */
(function(){
  var root = document.documentElement;
  window.__rvReady = true;


  var rvEls = Array.prototype.slice.call(document.querySelectorAll('.rv'));
  var idleBoxes = Array.prototype.slice.call(document.querySelectorAll('.hero, #auctions, #track, .marquee, #contact'));

  /* fallback: check positions on scroll (only used if the browser can't report what is on screen) */
  function scrollMode(){
    var pending = rvEls.filter(function(el){ return !el.classList.contains('in'); }), queued = false;
    function check(){
      queued = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      pending = pending.filter(function(el){
        var r = el.getBoundingClientRect();
        if (r.top < vh * .92 && r.bottom > 0) { el.classList.add('in'); return false; }
        return true;
      });
      for (var i = 0; i < idleBoxes.length; i++) {
        var b = idleBoxes[i].getBoundingClientRect();
        idleBoxes[i].classList.toggle('idle', b.bottom < -50 || b.top > vh + 50);
      }
    }
    function later(){ if (!queued) { queued = true; setTimeout(check, 60); } }
    window.addEventListener('scroll', later, { passive: true });
    window.addEventListener('resize', later);
    check();
  }
  if (!('IntersectionObserver' in window)) { scrollMode(); return; }

  /* normal case: the browser tells us when blocks come on screen, so scrolling costs nothing extra */
  var seen = false;
  var revealIO = new IntersectionObserver(function(es){
    seen = true;
    es.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('in'); revealIO.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' });
  var idleIO = new IntersectionObserver(function(es){
    seen = true;
    es.forEach(function(e){ e.target.classList.toggle('idle', !e.isIntersecting); });
  }, { rootMargin: '50px 0px' });
  rvEls.forEach(function(el){ revealIO.observe(el); });
  idleBoxes.forEach(function(el){ idleIO.observe(el); });
  setTimeout(function(){ if (!seen) { revealIO.disconnect(); idleIO.disconnect(); scrollMode(); } }, 1200);
})();
;
/* Optional: take Carfax payments in Shopify checkout.
   On when a Carfax product is picked in the theme editor (FM Motors home page section). */
(function(){
  var variant = window.FM_CARFAX_VARIANT;
  if (!variant) return;
  var btn = document.getElementById('cfx-send'), vin = document.getElementById('cfx-vin'), name = document.getElementById('cfx-name');
  var fine = document.querySelector('.cfx-fine');
  if (!btn || !vin) return;
  function setText(el, en, ar){
    if (!el) return;
    el.setAttribute('data-en', en); el.setAttribute('data-ar', ar);
    el.innerHTML = document.documentElement.getAttribute('lang') === 'ar' ? ar : en;
  }
  setText(btn, 'Order Carfax · $5', 'اطلب تقرير Carfax · 5$');
  setText(fine, 'Pay securely at checkout. We send the report to the email or WhatsApp you give us.', 'ادفع بأمان عند إتمام الطلب. نرسل لك التقرير على البريد الإلكتروني أو واتساب.');
  btn.removeAttribute('target');
  btn.addEventListener('click', function(e){
    var v = (vin.value || '').toUpperCase();
    if (v.length !== 17 || /[IOQ]/.test(v)) return; /* the VIN check shows its own message */
    e.preventDefault();
    var f = document.createElement('form');
    f.method = 'post'; f.action = window.FM_CART_ADD || '/cart/add';
    function add(n, val){ var i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = val; f.appendChild(i); }
    add('id', variant); add('quantity', '1'); add('properties[VIN]', v);
    if (name && name.value.trim()) add('properties[Name]', name.value.trim());
    add('return_to', '/checkout');
    document.body.appendChild(f);
    f.submit();
  });
})();
